import {
  createMutationStore,
  createQueryStore,
  useQueryClient,
} from '@ferreri/minato-react-utils';
import { alert } from '@ferreri/prever-component-lib';
import { useRouter } from 'next/router';

import {
  getPlanDistribution,
  getPlanDistributions,
  postPlanDistribution,
  putPlanDistribution,
} from './plan-distribution.client';
import {
  PlanDistributionData,
  PlanDistributionEdit,
} from './plan-distribution.types';

export const usePlanDistributions = () => {
  return createQueryStore({
    queryKey: ['plan_distributions'],
    queryFn: getPlanDistributions,
    refetchOnWindowFocus: false,
  });
};

export const usePlanDistributionIdRouteParam = (): string => {
  const router = useRouter();

  return router.query?.plan_distribution_id as string;
};

const usePlanDistribution = (id: number) => {
  return createQueryStore({
    queryKey: ['plan_distribution', id],
    queryFn: () => getPlanDistribution(id),
    enabled: Boolean(id),
  });
};

export const useCurrentPlanDistribution = () => {
  const planDistributionId = usePlanDistributionIdRouteParam();

  return usePlanDistribution(Number(planDistributionId));
};

export const useUpdatePlanDistribution = () => {
  const router = useRouter();
  const queryClient = useQueryClient();

  return createMutationStore({
    mutationFn: (data: PlanDistributionEdit) => putPlanDistribution(data),
    onSuccess: (variables) => {
      queryClient.invalidateQueries(['plan_distributions']);
      queryClient.invalidateQueries(['plan_distribution', variables.id]);

      router.push('/admin/plan-distributions');
    },
    onError: () => {
      alert.helper(
        'Erro ao atualizar distribuição',
        'Os dados da distribuição estão incorretos. Por favor, preencha os campos novamente.',
      );
    },
  });
};

export const useCreatePlanDistribution = () => {
  const router = useRouter();
  const queryClient = useQueryClient();

  return createMutationStore({
    mutationFn: (data: PlanDistributionData) => postPlanDistribution(data),
    onSuccess: () => {
      queryClient.invalidateQueries(['plan_distributions']);

      router.back();
    },
    onError: () => {
      alert.helper(
        'Não é possível adicionar essa distribuição',
        'Já existe uma distribuição criada com estas informações.',
      );
    },
  });
};
